export const logosList = [
  {
    title: "Chanti Photography",
    description: "A creative photography brand capturing life’s precious moments with artistic flair and professionalism.",
    link: "/projects",
    image: "/logos/logo1.jpeg",
  },
  {
    title: "CVK Water Proofing",
    description: "Specialists in waterproofing solutions for residential and commercial buildings, ensuring long-lasting protection.",
    link: "/logos",
    image: "/logos/logo2.jpeg",
  },
  {
    title: "Krishna Info Tech",
    description: "An innovative IT service provider offering reliable software solutions and technical support for businesses.",
    link: "/posters",
    image: "/logos/logo3.jpeg",
  },
  {
    title: "Devika's World",
    description: "A YouTube channel that sh ares exciting journeys through travel, food, and family life — capturing moments from around the world.",
    link: "/projects",
    image: "/logos/logo4.jpeg",
  },
  {
    title: "MTR Car Wash",
    description: "Offering high-quality car wash and detailing services to keep your vehicle spotless and shining.",
    link: "/logos",
    image: "/logos/logo5.jpeg",
  },
  {
    title: "MTR Nest & Rest",
    description: "A cozy and affordable stay option providing comfort and convenience for short or long-term travelers.",
    link: "/posters",
    image: "/logos/logo6.jpeg",
  },
  {
    title: "Quick Drive",
    description: "An on-demand platform connecting car owners with professional drivers for a hassle-free driving experience.",
    link: "/posters",
    image: "/logos/logo7.jpeg",
  },
];
